import {pathOr} from 'ramda';
import {getPackageValueForEEC} from '@optimaxdev/analytics/mobile';

import {QuoteItemType} from 'constants/flow/flowTypesCart';
import {PRODUCT_TYPES} from 'constants/product';
import {getOptionByAlias} from 'features/wizardMs/libs/getOptionByAlias';

/**
 * Get package version names
 * @param {QuoteItemType} product - quoteItem product
 * @returns {string} Package name
 */
export const getPackage = (product: QuoteItemType): string => {
    if (product.type === PRODUCT_TYPES.CONTACT_LENSES)
        return getPackageValueForEEC(pathOr('', ['pack'], product));

    if ('options' in product)
        return (
            getOptionByAlias(product, 'package')?.title ||
            getOptionByAlias(product, 'thickness')?.title ||
            ''
        );

    return '';
};
